module.exports = __webpack_public_path__ + "static/media/peijianxiao1.3a70cb5f.png";